import React, { useEffect, useState } from "react";
import {doSignInWithEmailAndPassword, logInWithEmailAndPassword,signInWithGoogle, sendPasswordReset} from '../../firebase';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { getAuth } from "firebase/auth";


 function SignIn() {
  const application = useSelector((state)=>state.application);
  const navigate = useNavigate();
  const [email,setEmail] = useState('');
  const [password,setPassword] = useState('');
  const [resetBusy, setResetBusy] = useState(false);


  useEffect(()=>{
    if(application.currentUser&&application.currentUser.uid){
      navigate('/');
    }
  },[application.currentUser])
  const handleSubmit = (event) => {
    event.preventDefault();
 
    var ga = getAuth();
    doSignInWithEmailAndPassword(ga,email,password).catch(err=> {
      alert(err);
    });
  };

  const handleReset = async () => {
    if (!email) {
      alert('Enter your email above to receive a reset link.');
      return;
    }
    setResetBusy(true);
    try {
      await sendPasswordReset(email);
      alert('Password reset link sent.');
    } catch (err) {
      alert(err?.message || 'Unable to send reset link right now.');
    } finally {
      setResetBusy(false);
    }
  };

  return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e)=>{
                setEmail(e.target.value);
                var val = e.target.value;
              }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e)=>{
                var val = e.target.value;
                setPassword(val)
                var val = e.target.value;

              }}
            />
      
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Grid container>
              <Grid item xs>
                <Link variant="body1" onClick={handleReset} underline="hover" sx={{ cursor: resetBusy ? 'not-allowed' : 'pointer' }}>
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link href="/sign-up" variant="body1" >
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
  );
}
export default SignIn
